import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const NachReconciliationModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    submitted, nachReconciliationMode,
    // event handlers
    onSubmit, onCancelClick,
    //
    bankStatementTransactionId, onbankStatementTransactionIdChange, bankStatementTransactionIdError, setbankStatementTransactionIdError,
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Reconcile NACH Transaction'
        buttonLabel='Reconcile'
        cancelLabel='Cancel'
        isOpen={nachReconciliationMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='bankStatementTransactionId' label='Bank Statement Transaction Id'
            required={true} maxLength={100} autoFocus={true}
            value={bankStatementTransactionId} onChange={onbankStatementTransactionIdChange}
            error={bankStatementTransactionIdError} setError={setbankStatementTransactionIdError}
        />
    </ModalFormUI>

export default NachReconciliationModalUI
